var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.6C6.0236 2.6 2.8 5.73695 2.8 9.6C2.8 9.93137 2.53137 10.2 2.2 10.2C1.86863 10.2 1.6 9.93137 1.6 9.6C1.6 5.07452 5.29218 1.4 9.84 1.4L10 1.4C12.5148 1.4 14.7878 2.49284 16.4 4.24414V2C16.4 1.66863 16.6686 1.4 17 1.4C17.3314 1.4 17.6 1.66863 17.6 2V5.6C17.6 5.93137 17.3314 6.2 17 6.2H13.4C13.0686 6.2 12.8 5.93137 12.8 5.6C12.8 5.26863 13.0686 5 13.4 5H15.4728C14.1052 3.3879 12.1335 2.6 10 2.6ZM17.8 9.8C18.1314 9.8 18.4 10.0686 18.4 10.4C18.4 14.9255 14.7078 18.6 10.16 18.6L10 18.6C7.48518 18.6 5.21216 17.5072 3.6 15.7559V18C3.6 18.3314 3.33137 18.6 3 18.6C2.66863 18.6 2.4 18.3314 2.4 18V14.4C2.4 14.0686 2.66863 13.8 3 13.8H6.6C6.93137 13.8 7.2 14.0686 7.2 14.4C7.2 14.7314 6.93137 15 6.6 15H4.52717C5.89484 16.6121 7.86654 17.4 10 17.4C13.9764 17.4 17.2 14.263 17.2 10.4C17.2 10.0686 17.4686 9.8 17.8 9.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoPay);
export default __webpack_public_path__ + "static/media/auto-pay.6338ca62aefadcad423ac938281a6a11.svg";
export { ForwardRef as ReactComponent };